import { TFunction } from 'i18next';

import { ACCOUNT_PENDING_REFRESH, ACCOUNT_READY, ACCOUNT_WITHOUT_DATA, CREATION_IN_PROGRESS } from '@Models';

/**
 * How a supplier's status and connectors read to a human.
 *
 * Extracted so the CSV export renders the same words as the table. It used to
 * live inside `SupplierList`, which meant the export could only emit the raw
 * internal values (`ACCOUNT_READY`, `gs1_wrl`) under translated headers.
 */

export interface StatusLabel {
  label: string;
  tooltip: string;
}

export const getStatusLabel = (status: string, t: TFunction): StatusLabel => {
  switch (status) {
    case CREATION_IN_PROGRESS:
      return { label: t('Supplier.Progress'), tooltip: t('Supplier.ProgressTooltip') };
    case ACCOUNT_READY:
      return { label: t('Supplier.WithData'), tooltip: t('Supplier.WithDataTooltip') };
    case ACCOUNT_WITHOUT_DATA:
      return { label: t('Supplier.WithoutData'), tooltip: t('Supplier.WithoutDataTooltip') };
    case ACCOUNT_PENDING_REFRESH:
      return { label: t('Supplier.Pending'), tooltip: t('Supplier.Pending') };
    default:
      return { label: '', tooltip: '' };
  }
};

/**
 * Retailer names for connector slugs. Not translated — these are brand names,
 * identical in every locale. An unmapped slug falls through to itself rather
 * than rendering blank, so a newly added connector is visible instead of
 * silently missing.
 */
export const CONNECTOR_LABELS: Record<string, string> = {
  gs1_wrl: 'Walmart',
  soriana: 'Soriana',
};

export const getConnectorLabel = (slug: string): string => CONNECTOR_LABELS[slug] ?? slug;
